<template>
  <div class="filter" :class="`filter--${attribute.key}`">
    <div class="placeholders" v-if="$store.state.view.isLoading">
      <content-placeholders v-for="i in 8" :key="`placeholder-${i}`">
        <content-placeholders-text :lines="1" />
      </content-placeholders>
    </div>

    <template v-if="!$store.state.view.isLoading">
      <div class="expander">
        <h6 class="filter__name">{{ attribute.label }}</h6>

        <button
          class="expander__helper expander__helper--collapsed"
          @click="manuallyCollapsed = false"
          v-if="isCollapsed"
        ></button>

        <button
          class="expander__helper expander__helper--expanded"
          @click="manuallyCollapsed = true"
          v-if="!isCollapsed"
        ></button>
      </div>

      <vuescroll :ops="ops">
        <ul class="filter__sub" v-if="!isCollapsed">
          <li :key="`${attribute.key}--${option.slug}`" v-for="option in attribute.options">
            <label
              :for="`filter--${attribute.key}-${option.slug}`"
              :class="{ faded: option.excluded_filter }"
            >
              <input
                type="checkbox"
                :name="`filter--${attribute.key}-${option.slug}`"
                :id="`filter--${attribute.key}-${option.slug}`"
                :checked="
                  $store.state.filters.current[attribute.key] &&
                    $store.state.filters.current[attribute.key].includes(option.slug)
                "
                @change="setFilter($event, attribute.key, option.slug)"
              />
              <span class="filter__name">{{ option.name }}</span>
              <!--<span class="filter__name" v-if="displayCount !== '0'">
                ({{ option.filteredCount }})
              </span>-->
            </label>
          </li>
        </ul>
      </vuescroll>
    </template>
  </div>
</template>

<script>
import vuescroll from "vuescroll";

export default {
  name: "AttributeFilter",
  props: {
    attribute: Object
  },
  components: {
    vuescroll
  },
  data() {
    return {
      manuallyCollapsed: null,
      selectedOptions: [],
      displayCount: ws_vue_store.display_taxonomy_count,
      ops: {
        scrollPanel: {
          maxHeight: 200
        }
      }
    };
  },
  computed: {
    isCollapsed() {
      if (this.manuallyCollapsed !== null) {
        return this.manuallyCollapsed;
      }
      if (
        this.$store.state.filters.current.product_cat !== undefined &&
        this.$store.state.filters.current.product_cat.length
      ) {
        return this.$store.state.filters.current.product_cat.some(termId => {
          const selectedCategory = this.$store.state.categories.find(
            category => category.term_id === termId
          );
          if (selectedCategory && selectedCategory.collapsed !== null) {
            return selectedCategory.collapsed.some(
              collapsedAttributeSlug => `pa_${collapsedAttributeSlug}` === this.attribute.key
            );
          }
          return false;
        });
      }
      return false;
    }
  },
  methods: {
    setFilter(event, taxonomy, option) {
      this.$store.commit("changeCurrentPage", 1);
      if (event.target.checked) {
        this.$store.dispatch("addFilter", { taxonomy, option });
        return;
      }
      this.$store.dispatch("removeFilter", { taxonomy, option });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter {
  .expander {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 2rem;

    &__helper {
      margin-left: 1rem;

      &--no-sub,
      &--collapsed,
      &--expanded {
        height: 2rem;
        width: 2rem;
        border-radius: 10rem;
        display: inline-flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        padding: 0;
        line-height: 1;
        font-size: 0;
        position: relative;
      }

      &--collapsed,
      &--expanded {
        &:before {
          content: "";
          width: 1rem;
          height: 0.2rem;
          display: block;
        }
      }

      &--collapsed {
        background-color: $expander-color-main;
        color: $expander-color-secondary;

        &:before {
          background-color: $expander-color-secondary;
        }

        &:after {
          content: "";
          width: 0.2rem;
          height: 1rem;
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: $expander-color-secondary;
        }
      }

      &--expanded {
        color: $expander-color-main;
        background-color: $expander-color-secondary;

        &:before {
          background-color: $expander-color-main;
        }
      }
    }
  }

  &__sub {
    li {
      margin: 0.5rem 0;
      @include remove-margin-top-bottom;

      label {
        @include default-checkbox;

        &.faded {
          pointer-events: none;
          opacity: 0.3;
        }
      }
    }
  }
}
</style>
